import {
  TOOTH_TEMPLATES_LOADING,
  TOOTH_TEMPLATES_LOADED,
  TOOTH_TEMPLATES_FAILED,
  TOOTH_TEMPLATE_UPLOAD_LOADING,
  TOOTH_TEMPLATE_UPLOAD_SUCCESS,
  TOOTH_TEMPLATE_UPLOAD_FAILED,
} from '../actions/types';

const initialState = {
  loading: false,
  uploading: false,
  templates: {
    molar: null,
    nonMolar: null,
    bridge: null,
  },
  error: null,
};

export default function toothTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case TOOTH_TEMPLATES_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TOOTH_TEMPLATES_LOADED:
      return {
        ...state,
        loading: false,
        templates: action.payload,
      };
    case TOOTH_TEMPLATES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TOOTH_TEMPLATE_UPLOAD_LOADING:
      return {
        ...state,
        uploading: true,
      };
    case TOOTH_TEMPLATE_UPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
      };
    case TOOTH_TEMPLATE_UPLOAD_FAILED:
      return {
        ...state,
        uploading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
